import { EntityTypes } from '../../../new-lib/constants/common';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import EntityLayout from '../components/layout/EntityLayout';
import StickyDetails from '../components/entity-details/StickyDetails';
import Description from '../components/Description';
import Areas from '../components/Areas';
import OfferCardsContainer from '../components/OfferCardsContainer';
import { EntityOffer } from '../../../new-lib/types/entity';
import LaunchesBannerContainer from '../launch/components/LaunchesBanner/LaunchesBannerContainer';
import ExplorePropertiesContainer from '../components/explore-properties/ExplorePropertiesContainer';

interface DeveloperViewProps {
  developer: any;
  offers: EntityOffer[];
  launches: any;
  filterOptions: any;
  breadcrumbs: React.ReactElement;
}
const DeveloperView = ({
  developer,
  offers,
  launches,
  filterOptions,
  breadcrumbs
}: DeveloperViewProps) => {
  return (
    <EntityLayout>
      {breadcrumbs}
      <div className="main-container">
        <div className="details-side full-width">
          <StickyDetails
            entity={developer}
            entityType={EntityTypes.DEVELOPER}
            contactEventExtraParams={{
              entity_type: EntityTypes.DEVELOPER,
              dev_id: developer.id,
              dev_name: developer.name
            }}
          />
          {developer.areas_count > 0 && (
            <Areas entityType={EntityTypes.DEVELOPER} areas={developer.areas} />
          )}

          {offers.length > 0 && (
            <OfferCardsContainer offers={offers} entity={developer} />
          )}

          <LaunchesBannerContainer launches={launches} />
          {developer.no_of_properties > 0 && (
            <ExplorePropertiesContainer
              entityDetails={{
                type: SearchFiltersTypes.DEVELOPERS,
                id: developer.id,
                name: developer.name
              }}
              filterOptions={filterOptions}
              exploreLocation="PropertiesInDeveloperSection"
            />
          )}
          {developer.description && (
            <Description
              headtxt={developer.name}
              description={
                <div
                  dangerouslySetInnerHTML={{ __html: developer.description }}
                />
              }
            />
          )}
        </div>
      </div>
    </EntityLayout>
  );
};
export default DeveloperView;
